<template>
    <div class="Bgc-white" v-if="banToken">
        <Header/>
            <div class="content">
                <div class="reservaciones">
                    <Sidebar/>
                    <Panel/>
                        <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>


      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->
                </div>
            </div>
        <Footer/>
    </div>
</template>

<script>
import * as GlobalFunctions from "../../../utils/GlobalFunctions";
import Panel from '../Elementos.vue';
import Sidebar from '../SidebarTop.vue';
import Modal from '../../addons/Modal.vue'
import i18n from '../../../plugins/i18n';
import SecureLS from 'secure-ls';
import axios from 'axios';
import Header from '../../generales/Header.vue';
import Footer from '../../generales/Footer.vue';

export default {
    name: 'Reservaciones',
    components: {
        Header,
        Panel,
        Sidebar,
        Footer,
        Modal
    },
    data() {
        return {
            banToken: false,
            isExpiredModalVisible: false
        }
    },
    beforeCreate(){
        GlobalFunctions.tokenExistValidate().then(response => {
            if(!response){
                let ls = new SecureLS({encodingType: 'aes'});
                this.isExpiredModalVisible = true
                this.banToken = true;
                               
            } else{
                this.banToken = true;
            }
        });
    },
    methods: {
        closeExpiredModal() {
                this.isExpiredModalVisible = false
             var ls = new SecureLS({encodingType: 'aes'});
                 GlobalFunctions.localStorageClean();
                this.$router.push({ name: "Login" });
        },
             clearLocalStorage() {
        this.isExpiredModalVisible = true



            },
    },
    created() {
this.$store.commit('firstChange', {enable: false})
            var ls = new SecureLS({encodingType: 'aes'});
          var a = ''  
       a = ls.get('Token') // localStorage.getItem('Token');
       this.token = a.data.substr(1);
       this.language = ls.get('Language'); // localStorage.getItem('Language');
       this.profile = ls.get('Profile'); // localStorage.getItem('Language');
    }
}
</script>

<style lang="scss" scoped>
    .reservaciones {
        width: 100%;
    }
</style>